import { AttributeLike } from './products/ascend-quest';
import { HasExclusiveSubcodes } from './services';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';

export const areAttributesSame = (
  left: AttributeLike,
  right: AttributeLike,
): boolean => {
  return (
    left.code === right.code &&
    left.category === right.category &&
    left.group === right.group
  );
};

export const doesSubcodeHaveAccess = (
  subCode: string | undefined,
  exclusiveSubcodes: string[] | undefined = [],
  treatEmptyExclusiveSubcodesAsApproved = true,
): boolean => {
  if (!subCode) {
    return false;
  } else if (
    exclusiveSubcodes.length === 0 &&
    !treatEmptyExclusiveSubcodesAsApproved
  ) {
    return false;
  } else if (
    exclusiveSubcodes.length === 0 &&
    treatEmptyExclusiveSubcodesAsApproved
  ) {
    return true;
  }
  const toReturn = exclusiveSubcodes.includes(subCode);
  return toReturn;
};

export const filterRecordsForSubcode = <T extends HasExclusiveSubcodes>(
  subCode: string,
  input?: T[],
): T[] => {
  return (input || []).filter((a) =>
    doesSubcodeHaveAccess(subCode, a?.exclusiveSubCodes),
  );
};

export const objectUtils = {
  areEqual: (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    other: any,
    ...ignoreProps: Array<string>
  ): boolean => {
    return isEqual(omit(value, ignoreProps), omit(other, ignoreProps));
  },
  isEmpty,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  areAllPropsEmpty: (object: Record<string, any>): boolean =>
    Object.values(object).every((x) => x === null || x.toString() === ''),
};

export const getProductNameFromRouterPath = (productEnum: string): string => {
  if (!productEnum) {
    return '';
  }
  return productEnum
    .split('-')
    .map((a) => a.charAt(0).toUpperCase() + a.substring(1))
    .join('');
};
